import { X } from "lucide-react";
import { t } from "../i18n";

export function HostChip({
  host,
  canRemove,
  onRemove,
}: {
  host: string;
  canRemove: boolean;
  onRemove: () => void;
}) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-stone-200 bg-stone-50 px-2.5 py-1 text-xs dark:border-white/10 dark:bg-white/6">
      <code>{host}</code>
      {canRemove && (
        <button
          type="button"
          className="rounded-full p-0.5 text-stone-400 hover:bg-stone-200 hover:text-stone-700 dark:hover:bg-white/10 dark:hover:text-white"
          aria-label={t("Remove {host}").replace("{host}", host)}
          onClick={onRemove}
        >
          <X size={12} />
        </button>
      )}
    </span>
  );
}
